// @ts-nocheck
import { IAddEntityModalParameters } from '../models/AddEntityModalParameters';
import { ModalTypes } from '../const/ModalTypes';

export enum ModalActions {
  SET_MODAL_STATE = 'SET_MODAL_STATE',
}

export interface ModalState {
  isModalOpen: boolean;
  modalType: ModalTypes | null;
  modalParameters: IAddEntityModalParameters | null;
  onCreateEntity: (input: any) => void | null;
  onCreateEntities: (input: any[]) => void | null;
}

interface SetModalState {
  type: ModalActions.SET_MODAL_STATE;
  payload: {
    isModalOpen: boolean;
    modalType: ModalTypes | null;
    modalParameters: IAddEntityModalParameters;
    onCreateEntity: (input: any) => void;
    onCreateEntities: (input: any[]) => void | null;
  };
}

export type ModalAction = SetModalState;
